import { render } from "./TalentDev.vue?vue&type=template&id=03abb194"
import script from "./TalentDev.vue?vue&type=script&lang=js"
export * from "./TalentDev.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__